import { render, staticRenderFns } from "./scoreList.vue?vue&type=template&id=7280a06e&scoped=true&"
import script from "./scoreList.vue?vue&type=script&lang=js&"
export * from "./scoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280a06e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7280a06e')) {
      api.createRecord('7280a06e', component.options)
    } else {
      api.reload('7280a06e', component.options)
    }
    module.hot.accept("./scoreList.vue?vue&type=template&id=7280a06e&scoped=true&", function () {
      api.rerender('7280a06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/scoreList.vue"
export default component.exports